'use strict';

import { appState, authState } from './appState.js';
import { setUrlParam, getUrlParam, urlSafe } from './urlTools.js';
import { sleep, nextFrame, makePromise, makeResolvedPromise } from './asyncTools.js';
import { lmAppStorage } from './lmAppStorage.js';
import { VarMgr } from './VarMgr.js';
import { newCustomDialog, newCustomView1 } from './mod-bridge.js';
import { notifyShutdown, notifyShutdownOff } from './ShutdownNotify.js';
import { transGet, transAdd } from './transTools.js';
import { ajaxWrapNew, mPost, CommandRegistry, GlobalResponseHandler } from './ajaxWrapNew.js';

export const lmApp = {

};
/* export const lmTools = {
    appState,
    authState,
    setUrlParam, getUrlParam, urlSafe,
    sleep, nextFrame, makePromise, makeResolvedPromise,
    lmAppStorage,
    VarMgr,
    transGet, transAdd,
    ajaxWrapNew, mPost, CommandRegistry, GlobalResponseHandler
};
 */
const defaultCommands = {
    trigger: (payload) => $(window).trigger(payload),
    alert: (payload) => alert(payload),
    consoleLog: (payload) => console.log(payload),
    consoleError: (payload) => console.error(payload),

    addBack: (payload) => {
        lmAppStorage.saveBack(payload.key, payload.url);
        //document.dispatchEvent(new CustomEvent('app-storage:saveback', { detail: { key: payload.key, url: payload.url } }));
    },
    hidepage: () => $('.wbouter').hide(),

    open: (payload) => window.open(...(Array.isArray(payload) ? payload : [payload])),
    urlReplace: (payload) => {
        const currentState = history.state || {};
        appState.historyInstance.replaceState(currentState, null, payload);
    },
    urlAssign: (payload) => urlSafe.historyAssign(payload),
    urlRedirect: (payload) => urlSafe.historyRedirect(payload),
    urlReload: () => urlSafe.historyReload(),
    loginRequired: (payload) => {
        if (payload.withNotification) {
            showToast(transGet('LOGIN_REQUIRED', 'This action requires logging in.'));
            setTimeout(() => {
                urlSafe.historyAssign(payload.url);
            }, 2000);
        } else {
            urlSafe.historyAssign(payload.url);
        }
    },
    showToast: async (payload) => {
        const { message, type = 'info', duration = 3000, awaitFlag = false } = payload;
        showToast(message, type, duration);
        if (awaitFlag) {
            await new Promise(resolve => setTimeout(resolve, duration));
        }
    },

    append: (payload) => {
        $.each(payload, (index, item) => {
            if (item.remove) {
                $(item.remove).remove();
            }
            $(item.to).append(item.html);
        });
    },

    optionsMenu: (payload) =>  {
        $('.nv-options-wrapper').after(
            $('<div class="nv-options"></div>').append(payload)
        );
    },

    // jaunie modālie
    openModal: async (payload) => {
        await doOpenModal(payload);
    },

    // vecie modālie
    customDialog: (payload) => {
        newCustomDialog(payload);
    },
    customView1: (payload) => {
        newCustomView1(payload);
    },
    closeLastDialog: async (payload) => {
        if (window['lastCustomDialog']) {
            var closedPromise = makePromise();
            window['lastCustomDialog'].conf.onClose = function () {
                closedPromise.resolve();
            };
            window['lastCustomDialog'].close();
            if (payload === 'wait') {
                await closedPromise.promise;
            }
        }
    },
    PINStopBack: async (payload) => {
        const pinDialog = $('.pin-input-dialog').data('pinDialog');
        if (pinDialog) {
            pinDialog.options.backOnCloseOff = true;
            pinDialog.backOnClose = false
        }
    },
    closePINDialog: async (payload) => {
        const pinDialog = $('.pin-input-dialog').data('pinDialog');
        if (pinDialog) {
            var closedPromise = makePromise();
            pinDialog.onClose = function () {
                closedPromise.resolve();
            };
            pinDialog.close();
            if (payload === 'wait') {
                await closedPromise.promise;
            }
        }
    },

    // pin ??
    changePin: () => {
        window.AppBridge.PinChange();
    },

    // silent
    miracleSync: (payload) => { console.log('miracleSync command received', payload); },


};

async function refreshCryptConf() {
    const newData = await mPost('cryptAuthGETJS', {
        type: appState.globalCrypter.isGuest ? 'guest' : 'user'
    }, false, true);
    if (newData && newData.setGlobalCryptAuth) {
        await updateGlobalCryptConf(newData.setGlobalCryptAuth);
    }
}

async function updateGlobalCryptConf(conf) {
    appState.setGlobalCryptConf(conf);
    await cryptConfChanged(appState.getGlobalCryptConf());
}

async function cryptConfChanged(newCryptConf = null) {
    if (typeof appState.globalCrypter !== 'undefined' && appState.globalCrypter) {
        await appState.globalCrypter.confChanged(newCryptConf);
    }
}

const defaultResponseHandler = async (response) => {
    // Salīdzinam vai nav mainijies šifrēšanas konfid un ja ir, tad atsvaidzina to, lai jaunā vērtība būtu pieejama visur tālākajā koda izpildē
    if (typeof response.cryptId != 'undefined') {
        if (response.cryptId !== appState.globalCrypter?.cryptConf?.crypt?.cryptId) {
            // šis arī izsauks setGlobalCryptConf;
            await refreshCryptConf();
        }
    }
    if (response.setGlobalCryptAuth) {
        await updateGlobalCryptConf(response.setGlobalCryptAuth);
    }

    if (response.transAdd) {
        transAdd(response.transAdd);
    }

    // Šis pagaidām pēc transAdd jo šim vajag tulkojumus;
    if (response.notifyShutdown) {
        notifyShutdown(response.notifyShutdown);
    } else if ($('.update-notify-wr').length) {
        notifyShutdownOff();
    }

    if (response.closeLastDialog) {
        if (window['lastCustomDialog']) {
            var closedPromise = makePromise();
            window['lastCustomDialog'].conf.onClose = function () {
                closedPromise.resolve();
            };
            window['lastCustomDialog'].close();
            await closedPromise.promise;
        }
    }

    return true;
};

CommandRegistry.registerCommands(defaultCommands);
GlobalResponseHandler.registerHandler(defaultResponseHandler);

window.registerDebugCallback('authState', (data) => {
    return {
        cold: authState.getColdState().loggedIn,
        curr: authState.getAuthState().loggedIn,
        uid: VarMgr.get('UID', ''),
        profilename: VarMgr.get('PROFILENAME', '')
    };
});
window.registerDebugCallback('state', (data) => {
    const returnData = {
        reloading: appState.reloading,
        unlocking: appState.unlocking,
        waitingAutoDecrypt: appState.waitingAutoDecrypt
    };
    if (appState.globalCrypter) {
        returnData.globalCrypter = {
            ready: appState.globalCrypter.ready,
            action: appState.globalCrypter.action
        };
    }
    return returnData;
});


async function doOpenModal(data) {
    if (data.type == 'miracleCity') {
        return openMiracleCityModal(data);
    }
}

async function openMiracleCityModal(data) {
    const miracleCityModal = await window.AppBridge.miracleCityModal();
    if (!miracleCityModal) {
        console.error('miracleCityModal not found');
        return;
    }
    const $chat = $('.floatingChat');

    miracleCityModal.init($.extend({}, data, {
        onSelect: function (result) {
            if (data.changeLocation) {
                $chat.trigger('changeLocation', {
                    chat: data.chat,
                    location: result.location,
                    country: result.country,
                    favId: result.favId,
                    locationTitle: result.locationTitle,
                    selectionChanged: result.selectionChanged
                });
            } else {
                const prevLocation = $chat.data('location');
                const prevCountry = $chat.data('country');
                $chat.data('location', result.location);
                $chat.data('country', result.country);
                $chat.data('favid', result.favId);

                // saglabājam arī šeit taitlu, priekš animācijas;
                $chat.attr('data-locationtitle', result.locationTitle);
                $chat.attr('data-locationtitleanim', result.locationTitle);

                // noņemam saglabāto url, ar nelielu laika nobīdi jo tiek veikts history.back()
                // lai uz reload vai refresh nepaliek vecais url city un country;
                setTimeout(() => {
                    setUrlParam({
                        country: false,
                        location: false
                    });
                    appState.historyInstance.toggleUrls({
                        country: false,
                        location: false
                    });
                }, 200);

                if ((prevCountry === undefined && result.selectionChanged) || (prevCountry !== undefined && (prevLocation != result.location || prevCountry != result.country))) {
                    /* showLocationAnimation({
                        locationTitle: result.locationTitle
                    }); */
                    dispatchEvent(new CustomEvent('miracles:showLocationAnimation', {
                        detail: {
                            locationTitle: result.locationTitle
                        }
                    }));
                }
            }
        },
        isLocationChange: data.changeLocation || false
    }));
}
